import { all, fork } from "redux-saga/effects";
import loginSaga from './auth/login/saga';

//public
import ForgetSaga from "./auth/forgetpwd/saga";
import AuthSaga from "./auth/login/saga";
import ProfileSaga from "./auth/profile/saga";
import AccountSaga from "./auth/register/saga";
import calendarSaga from "./calendar/saga";
import chatSaga from "./chat/saga";
import LayoutSaga from "./layout/saga";
import tasksSaga from "./tasks/saga";


export default function* rootSaga() {
  yield all([
    //public
    AccountSaga(),
    fork(AuthSaga),
    ProfileSaga(),
    ForgetSaga(),
    LayoutSaga(),
    fork(calendarSaga),
    fork(chatSaga),
    fork(tasksSaga),
    fork(tasksSaga),
    loginSaga(),

  ])
}
